import { render, staticRenderFns } from "./SitesProjectsSettings.vue?vue&type=template&id=32b8ca19&scoped=true"
import script from "./SitesProjectsSettings.vue?vue&type=script&lang=js"
export * from "./SitesProjectsSettings.vue?vue&type=script&lang=js"
import style0 from "./SitesProjectsSettings.vue?vue&type=style&index=0&id=32b8ca19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8ca19",
  null
  
)

export default component.exports